import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import {BreadcrumbsBlock as Breadcrumbs} from "@arctheme-components/blocks/BreadcrumbsBlock/Breadcrumbs";
import ActionBar from "@arctheme-components/blocks/ActionBar/ActionBar";

const OverlayedLayout = ({ blocks, settings }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  const renderBlock = (block, index) => {
    const commonClasses = `
      text-${block.settings.content_alignment_mobile} lg:text-${block.settings.content_alignment_desktop}
      pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]
      pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px]
      pl-[${block.settings.padding_left_mobile}px] lg:pl-[${block.settings.padding_left_desktop}px]
      pr-[${block.settings.padding_right_mobile}px] lg:pr-[${block.settings.padding_right_desktop}px]
    `;
    switch (block.type) {
      case "description":

      const textStyle = isMobile
        ? block.settings.text_style_mobile
        : block.settings.text_style;

        return (
          <div
            key={index}
            className={`${textStyle} ${commonClasses}`}
          >
            <Paragraph text={block.settings.text} type={`b2`} />
          </div>
        );
      case "title":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <h1 className={`hidden lg:block ${block.settings.heading_type}`}>
              {block.settings.title}
            </h1>
            <h1
              className={`lg:hidden block ${block.settings.heading_type_mobile}`}
            >
              {block.settings.title}
            </h1>
          </div>
        );
      case "tagline":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <h1 className={`hidden lg:block ${block.settings.heading_type}`}>
              {block.settings.text}
            </h1>
            <h1
              className={`lg:hidden block ${block.settings.heading_type_mobile}`}
            >
              {block.settings.text}
            </h1>
          </div>
        );
      case "breadcrumbs":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <Breadcrumbs
              templateName={"page"}
              shop={settings.shop}
              page={settings.page}
              request={settings.request}
            />
          </div>
        );
      case "sociallinks":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <ActionBar
              label={block.settings.action_text}
              altLinks={{
                x_url: block.settings.x_url,
                facebook_url: block.settings.facebook_url,
                instagram_url: block.settings.instagram_url,
                linkedin_url: block.settings.linkedin_url,
              }}
            />
          </div>
        );
      case "button":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <a href="#" className={`${block.settings.button_type}`}>
              {block.settings.text}
            </a>
          </div>
        );
      case "actions":
        return (
          <div
            key={index}
            className={commonClasses}
          >
            <div className={"actions__container flex items-center gap-x-[8px]"}>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-phone-call text-[20px]`}></i>{" "}
                <a href={`tel:${block.settings.phone}`}>Call Us</a>
              </div>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-mail-send text-[20px]`}></i>{" "}
                <a href={`mailto:${block.settings.email}`}>Email</a>
              </div>
              <div
                className={
                  "actions__container-action flex items-center gap-x-[8px]"
                }
              >
                <i className={`icon icon-face text-[20px]`}></i>{" "}
                <a href={`${block.settings.chat}`}>Live Chat</a>
              </div>
            </div>
          </div>
        );
      case "image":
        const imageUrl =
          isMobile && block.settings.image_mobile
            ? block.settings.image_mobile
            : block.settings.image;

        return (
          <div
            className={`page-header__overlayed-img ${block.settings.darken_image && "content-over-media"}`}
          >
            <img key={index} src={imageUrl} alt="" />
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div
      className={`page-header__overlayed w-full flex text-center h-[${settings.section.header_height}px] overflow-hidden`}
    >
      <div
        className={`left-panel relative flex flex-col justify-center color-${settings.section.color_schema}`}
      >
        {blocks.map(renderBlock)}
      </div>
    </div>
  );
};

export default OverlayedLayout;
